import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./Components/Utils/ScrollToTop";

import "./index.css";
import App from "./App";

import { GlobalProvider } from "./Components/Context/GlobalContext";
import { CartProvider } from "./Components/Context/CartContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
    <ScrollToTop />
      <GlobalProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </GlobalProvider>
    </BrowserRouter>
);
